import { adminPortal } from "./adminPortal.routes";
import { customerPortal } from "./customerPortal.routes";
import { funnel } from "./funnel.routes";
import { website } from "./website.routes";
import { thirdParty } from "./thirdParty.routes";
import { TRouteMap, TRouteName, TRoutes } from "../routes.types";

export const routes: TRouteMap = {
  website,
  customerPortal,
  funnel,
  adminPortal,
  thirdParty,
} satisfies Record<TRouteName, TRoutes>;
